/** @jsx jsx */
import { jsx } from 'theme-ui'
import Reviews from '~/components/Reviews'

const ReviewsSection = ({ bgOverride, title = null }) => {
  return <Reviews background={bgOverride} title={title} />
}

export default ReviewsSection
